import e from "./CopyLinkButton.vue.script.js";
//#region src/schema/components/CopyLinkButton.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=CopyLinkButton.vue.js.map